import React, { Component, Suspense } from "react";
import { withRouter } from "react-router-dom";
import FreeTrialBanner from "../../components/Utils/FreeTrialBanner";

// Layout Components
const Topbar = React.lazy(() => import("./Topbar"));
const Footer = React.lazy(() => import("./Footer"));

class Layout extends Component {
  Loader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <div className="double-bounce1"></div>
            <div className="double-bounce2"></div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        <Suspense fallback={this.Loader()}>
          {/* <FreeTrialBanner /> */}

          <Topbar />

          {this.props.children}

          {this.props.noFooter ? null : <Footer />}
        </Suspense>
      </React.Fragment>
    );
  }
}

export default withRouter(Layout);
